import api from '../client'

export async function fetchBranchOptions(search = '', page = 1, pageSize = 20, companyIds = null) {
  const params = { search, page, page_size: pageSize }
  if (companyIds && companyIds !== 'All') {
    params.company_ids = Array.isArray(companyIds) ? companyIds.join(',') : String(companyIds)
  }
  const { data } = await api.get('/options/branches', { params })
  const rawItems = Array.isArray(data) ? data : Array.isArray(data?.items) ? data.items : []
  const items = rawItems.map((item) => ({
    value: String(item.id),
    label: item.name || item.code || String(item.id),
    companyName: item.companyName,
  }))
  const hasMore = rawItems.length === pageSize
  return { items, hasMore }
}
